function wu_main_nav() {

  $('.nav__academics .sub-menu a').hover(function() {
    var school = $(this).attr('data-school');
      if($(this).parents('ul').hasClass('list--schools')) {
        $('.nav__academics ul a[data-school="'+school+'"]').addClass('active');
      }
      else {
        $('.nav__academics ul.list--schools a[data-school="'+school+'"]').addClass('active');
      }
    }, function() {
      $('.nav__academics ul a').removeClass('active');
  });

}



function wu_mobile_nav() {

  //Trigger Mobile Nav Opening
  $('.nav__trigger').on('click tap', function(e){
    e.preventDefault();
    $('#nav__main').toggleClass('hidden-sm hidden-xs');
    $(this).toggleClass('active');
    $('body, html').toggleClass('no-scroll');
    $('.sub-menu').hide();
  });

  //Stop Top Level Links
  $('.nav__toplevel').on('mouseOver click tap', function(){
      thisSub = $(this).next();
      thisSub.toggle();

  });       

}


wu_main_nav();
wu_mobile_nav();
